module.exports = __webpack_public_path__ + "static/media/lock-dynamic-color.9b95357d.png";